import React, { Component } from 'react';
import {memoize} from "lodash";

export const cachedWithRouteOnEnter = memoize((component, callback) => {
  return withRouteOnEnter(callback)(component);
});

export const withRouteOnEnter = (callback) => (BaseComponent) => {
  const routeOnEnterCallback = (props) => {
    if (callback && typeof callback === 'function') {
      callback(props);
    }
  };

  class routeOnEnterComponent extends Component {
    componentWillMount() {
      routeOnEnterCallback(this.props);
      sessionStorage.removeItem('redirectUrl');
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.location !== this.props.location) {
        routeOnEnterCallback(nextProps);
      }
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  }

  return routeOnEnterComponent;
};